import { registerLocaleData } from '@angular/common'
import localeDe from '@angular/common/locales/de'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import {
  type ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core'
import { provideRouter, withNavigationErrorHandler } from '@angular/router'
import { DateWeekDays, LanguageService, provideBricksUi } from '@enbw_bricks/ui'
import { routes } from './app.routes'
import { authInterceptor } from './shared/auth/auth.interceptor'
import { AuthService } from './shared/auth/auth.service'
import { ModuleRegistry } from 'ag-grid-community'
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise'
import { CustomPaginatorIntl } from './shared/grid/paginator-intl'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { loadingSpinnerInterceptor } from './shared/interceptors/loading-spinner.interceptor'
import { maintenanceInterceptor } from './maintenance/maintenance.interceptor'

registerLocaleData(localeDe)

ModuleRegistry.registerModules([AllEnterpriseModule])
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-131332}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{EnBW_Energie_Baden-Wrttemberg_AG}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{OneDV_Portal}_only_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{OneDV_Portal}_need_to_be_licensed___{OneDV_Portal}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{6_July_2027}____[v3]_[01]_MTgxNDgyODQwMDAwMA==643277e5e08064bba6d41e80d5a19414'
)

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'de-DE' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withNavigationErrorHandler((event) => {
        const msg = String(event.error?.message ?? event.error ?? '')
        const isChunkError =
          /Failed to fetch dynamically imported module|error loading dynamically imported module|ChunkLoadError/i.test(
            msg
          )
        if (isChunkError) {
          // a new version was deployed; reload to pick up the fresh index.html + chunks
          globalThis.location.assign(event.url)
        }
      })
    ),
    // maintenance runs first so it sees the final result after the other interceptors are done
    provideHttpClient(withInterceptors([maintenanceInterceptor, authInterceptor, loadingSpinnerInterceptor])),
    provideBricksUi({
      locale: 'de-DE',
      datePickerOptions: {
        firstDayOfWeek: DateWeekDays.MONDAY,
      },
    }),
    provideAppInitializer(() => inject(LanguageService).setLanguage('de')),
    provideAppInitializer(() => inject(AuthService).initializeAuth()),
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
  ],
}
